<script setup>

import {computed, ref, watch} from "vue";
import { PlusIcon, XIcon } from "@heroicons/vue/outline"
import {debounce} from "lodash";

const emit = defineEmits(['addFieldOption', 'removeFieldOption'])

const props = defineProps({
    field: {
        type: Object,
        required: true,
    },
    parameters: {
        type: Object,
        required: true,
    },
    placeholder: {
        type: String,
        required: false,
        default: '',
    },
    disabled: { type: Boolean, default: false },
})

const textInput = ref('')
const suggestions = ref([])
const showSuggestions = ref(false)
const selectedIndex = ref(-1)

// Ensure parameters[field.field] is initialized as an array
if (!props.parameters[props.field.field]) {
    props.parameters[props.field.field] = []
}

const addTextInput = () => {
    if (props.disabled) return

    if (textInput.value.trim() === '') return

    emit('addFieldOption', props.field, {label: textInput.value, value: textInput.value})
    textInput.value = ''
}

const removeTextInput = (option) => {
    if (props.disabled) return

    emit('removeFieldOption', props.field, option)
}

const clearFilter = () => {
    textInput.value = ''
}

</script>

<template>
    <div>
        <div class="relative">
            <div class="relative">
                <input-text
                    :placeholder="props.placeholder"
                    v-model:content="textInput"
                    @keyup.enter="addTextInput()"
                    :disabled="disabled"
                ></input-text>
                <div class="absolute right-2 top-2.5">
                    <button-primary
                        v-if="!disabled && textInput.length > 1"
                        @click="addTextInput()"
                        size="sm"
                    >
                        {{ _mft('shared:add') }}
                    </button-primary>
                </div>
            </div>

            <ul
                v-if="parameters[field.field] && parameters[field.field].length > 0"
                class="-mt-2 flex flex-wrap items-center px-0.5"
            >
                <li
                    v-for="(option, o) in parameters[field.field]"
                    :key="o"
                    class="mr-1 mb-1"
                >
                    <pill>
                        <div class="flex space-x-1">
                            <div>{{ option.label }}</div>
                            <button
                                v-if="!disabled"
                                @click="removeTextInput(option)"
                            >
                                <XIcon class="h-4 w-4" />
                            </button>
                        </div>
                    </pill>
                </li>
            </ul>
        </div>
    </div>
</template>

<style scoped>

</style>
